<template>
  <div id="protocolandrules" v-wechat-title="$route.meta.title">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name:"protocolandrules"
}
</script>

<style>
html,body{
  width: 100%;
  overflow-x: hidden;
}
body{
  background: #fff;
}
body,html,div,p,span,ul,li,a,video,dl,dt,dd{
  margin: 0;
  padding: 0;
}
body{
  font-family: PingFang,Lucida Grande,Arial,Lucida Sans Unicode,Helvetica Neue,Hiragino Sans GB,Microsoft Yahei,Sans-serif,San Francisco UI;
}
ul,li{
  list-style: none;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}
input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{
  color:#ccc;
}
input::-moz-placeholder,textarea::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color:#ccc;
}
input:-moz-placeholder,textarea:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color:#ccc;
}
input:-ms-input-placeholder,textarea:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
  color:#ccc;
}
</style>
